
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { ButtonToggler } from "@/utilities/ButtonToggler";
    import { Contractor, IContractor } from '@/model/Contractor';
    import { required, email } from "vuelidate/lib/validators";
    import { User, IUser } from "@/model/User";
    import { Utils } from "@/utilities/Utils";
    import { Validations } from "vuelidate-property-decorators";
    import { ScanHistoryVM, IScanHistoryVM } from "@/model/Api/VM/ScanHistoryVM";
    import { EmployeeScanHistoryRequest } from "@/model/Api/Params/EmployeeScanHistoryRequest";
    import { RedFlagMessageType, BookingActionDirection, BookingActionResult, ScanTiming } from "@/model/Enums";
    import { Watch } from "vue-property-decorator";
    import BookingActionDetailModal  from "@/views/Modals/BookingsModals/BookingActionDetailModal.vue";

    interface IEmailIsInUseResponse {
        isInUse: boolean;
    }

    interface IPasswordCheckResult {
        isOkay: boolean;
        message: string;
    }
    
    @Component({
        components: {
            ApiButton,
            BookingActionDetailModal
        }
    })

    export default class EmployeeScanHistoryModal extends Vue {

        //
        // -- properties
        //

        private scanEvents: Array<IScanHistoryVM> = []; 
        private redFlagOnly: boolean = false;
        private params = new EmployeeScanHistoryRequest(); 
        private employeeName: string = "";
        private isReseting: boolean = false;
        private isLoading: boolean = false;


        // computed property

        private get dialogueTitle(): string {
            if (this.redFlagOnly) return `${this.employeeName} Red Flag History`
            else return `${this.employeeName} Scan History`
        }

        private get messageType() {
            return Utils.enumToLookups(RedFlagMessageType);
        }

        private get directionType() {
            return Utils.enumToLookups(BookingActionDirection);
        }

        private get resultType() {
            return Utils.enumToLookups(BookingActionResult);
        }

        private get filteredResultType() {
            return this.resultType.filter(r => r.id > 0);
        }

        private get timingOptions() {
            return Utils.enumToLookups(ScanTiming);
        }

        private get hasRedFlag(): boolean {
            //|| (this.scanEvents.filter(s => s.timingOptions == ScanTiming.OutsideTimeRange).length > 0)
            if ((this.scanEvents.filter(s => s.redFlagMessageType != RedFlagMessageType.None).length > 0)) {
                return true;
            }
            else {
                return false;
            }
        }

        @Watch("params.startDate")
        onStartDateChanged(value: boolean) {
            if (this.isReseting == false) {
                this.loadScans();
            }
        }

        @Watch("params.endDate")
        onEndDateChanged(value: boolean) {
            if (this.isReseting == false) {
                this.loadScans();
            }
        }

        @Watch("params.resultType")
        onResultTypeChanged(value: boolean) {
            if (this.isReseting == false) {
                this.loadScans();
            }
        }

        @Watch("params.redFlagOnly")
        onRedFlagChanged(value: boolean) {
            if (this.isReseting == false) {
                this.loadScans();
            }
        }

        //
        // -- methods
        //

        refreshParams() {
            this.scanEvents = [];
            this.isReseting = true;
            this.params.startDate = null;
            this.params.endDate = null;
            this.params.resultType = 0;
            this.params.redFlagOnly = false;
            this.loadScans();
        }

        open(employeeID: number, name: string, redFlagOnly: boolean) {
            this.params.id = employeeID;
            this.employeeName = name;
            this.isReseting = true;
            if (redFlagOnly == true) {
                this.params.redFlagOnly = true;
                this.redFlagOnly = true;
            }
            // reset obj here
            this.loadScans();
            this.$bvModal.show("employeeScanHistoryModal");
        }

        openActionDetail(id: string, event: Event) {
            const dialogue = this.$refs.bookingActionDetailModal as BookingActionDetailModal & { show: () => void };
            dialogue.open(id);
        }

        async loadScans() {
            this.isLoading = true;
            this.scanEvents = [];
            //this.bookingActions = [];
            const response = await ApiClient.post(`/Api/Contractor/EmployeeScanHistory`, this.params);
            this.scanEvents.push(...response.map((r: IScanHistoryVM) => new ScanHistoryVM(r)));
            this.isReseting = false;
            this.isLoading = false;
        }
        
        cancel() {
            this.$bvModal.hide("employeeScanHistoryModal");
            //Utils.resetObject(this.contractor);
            //Utils.resetObject(this.user);
        }


    }

